// extracted by mini-css-extract-plugin
export var columnItem = "_cx-3";
export var columnItemDraggable = "_cx-5";
export var dragHandle = "_cx-0";
export var dragHandleHovered = "_cx-1";
export var dropdown = "_cx-6";
export var dropdownContent = "_cx-8";
export var dropdownInner = "_cx-7";
export var filterDropdownHeader = "_cx-9";
export var icon = "_cx-2";
export var moveToTopButton = "_cx-4";
export var sectionDivider = "_cx-a";